import { render, staticRenderFns } from "./zCampoTexto.vue?vue&type=template&id=c6e738b0&scoped=true&"
import script from "./zCampoTexto.vue?vue&type=script&lang=js&"
export * from "./zCampoTexto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6e738b0",
  null
  
)

export default component.exports